export default "__VITE_ASSET__cnsWy7zw__"